import type { SystemConfig } from '@/interfaces/systemConfig.interface';
import api from './base.api';

const BASE_PATH = '/system';

export const getSystemConfig = async () => {
  const response = await api.get<SystemConfig>(`${BASE_PATH}/configuration`);
  return response.data;
};
